import axios, { CancelTokenSource } from "axios";
import { useEffect, useState } from "react";
import { environmentVariables } from "../../env/environment-variables.ts";

export const useUpload = () => {
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isProgress, setIsProgress] = useState<boolean>(false);
  const [progress, setProgress] = useState<number>(-1);
  const [cancelToken, setCancelToken] = useState<CancelTokenSource | undefined>(
    undefined,
  );

  const cancel = axios.CancelToken.source();

  useEffect(() => {
    setCancelToken(cancel);
  }, []);

  const upload = async (formData: FormData) => {
    return await axios
      .post(`${environmentVariables.baseApiUrl}/assets`, formData, {
        cancelToken: cancel.token,
        withCredentials: true,
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const progress = Number(
            ((progressEvent.loaded / progressEvent.total!) * 100).toFixed(2),
          );
          setIsProgress(true);
          setProgress(progress);
        },
      })
      .then(async (response: { data: { key: string } }) => {
        setIsSuccess(true);
        setIsProgress(false);
        return response.data.key;
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          setProgress(-1);
          setIsProgress(false);
        }
        return Promise.reject(error);
      });
  };

  return {
    upload,
    isSuccess,
    progress,
    setIsSuccess,
    setProgress,
    cancelToken,
    isProgress,
  };
};
